import { RecipeIngredient } from '../types/recipe';
import { isNonFoodIngredientLine } from './nonFoodIngredientLine';

/**
 * Turn a recipe's stored `extendedIngredients` into the rows the ingredients
 * list renders.
 *
 * This used to be an inline `.map()` in the recipe-detail screen, which meant
 * every stored line became a row — including "Pour 4 personnes" and, on three
 * recipes, eight rows of nutrition panel, all rendered as checkable ingredients
 * counted toward "Les 9 autres sont à votre garde-manger" (#594).
 *
 * Filtering here rather than only at scrape time is deliberate: those lines are
 * already persisted on recipes in Firestore, so a read-path filter fixes them
 * without a backfill.
 */
export function toDisplayIngredients(
  extendedIngredients: RecipeIngredient[] | undefined | null
): RecipeIngredient[] {
  if (!extendedIngredients) return [];

  return extendedIngredients
    .map((ing, idx) => ({
      id: ing.id ?? idx,
      name: ing.name || '',
      original: ing.original || ing.name || '',
      amount: ing.amount || 0,
      unit: ing.unit || '',
      image: ing.image,
    }))
    .filter(ing => !isNonFoodIngredientLine(ing.original || ing.name));
}
